import Vue from 'vue'
import DownloadCsv from './downloadCsv'

Vue.use(DownloadCsv)

export default new DownloadCsv()
